import type { CreateCustomerData } from '../schemas'
import { isKidsAccount } from './isKids'

export const isParentAuthComplete = (data: Partial<CreateCustomerData>) => {
  if (!isKidsAccount(data)) {
    return true
  }

  const status = data.parentAuthStatus

  if (status === 'failed' || status === 'required' || status === 'pending') {
    return false
  }

  if (status === 'verified') {
    return !!data.parentData
  }

  return true
}

export const isKidsContactStepValid = (data: Partial<CreateCustomerData>) =>
  isParentAuthComplete(data)

export const clearParentAuth = (): Pick<
  CreateCustomerData,
  'parentAuthStatus' | 'parentData'
> => ({
  parentAuthStatus: undefined,
  parentData: undefined,
})
